export default __webpack_public_path__ + "static/media/other-registered.8d54d5be.png";